/* eslint-disable import/prefer-default-export */
export const MoypDetailViewSelector = ({
  moypdetailview: { GetMoypDetailView }
}) => GetMoypDetailView;
